import { render } from "./HolidayApprovalView.vue?vue&type=template&id=58c9ea8e&scoped=true"
import script from "./HolidayApprovalView.vue?vue&type=script&lang=js"
export * from "./HolidayApprovalView.vue?vue&type=script&lang=js"

import "./HolidayApprovalView.vue?vue&type=style&index=0&id=58c9ea8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c9ea8e"]])

export default __exports__